module.exports = __webpack_public_path__ + "img/13.7e4882a2.jpg";